import { render, staticRenderFns } from "./_typography.vue?vue&type=template&id=15863344&"
import script from "./_typography.vue?vue&type=script&lang=ts&"
export * from "./_typography.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15863344')) {
      api.createRecord('15863344', component.options)
    } else {
      api.reload('15863344', component.options)
    }
    module.hot.accept("./_typography.vue?vue&type=template&id=15863344&", function () {
      api.rerender('15863344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_showcase/atoms/_typography.vue"
export default component.exports